import axiosPrivate from "../../../api/axiosPrivate";
import {
  CREATE_CLAUSE,
  GET_ALL_CLAUSES,
  GET_SINGLE_CLAUSES,
  UPDATE_CLAUSE,
} from "../../../api/constant";

// Create new clause
const createClause = async (clauseData) => {
  const response = await axiosPrivate.post(CREATE_CLAUSE, clauseData);
  return response.data;
};

// Get all clauses
const getAllClauses = async ({pageNumber, search}) => {
  const response = await axiosPrivate.get(
    `${GET_ALL_CLAUSES}?page=${pageNumber}&search=${search}`
  );
  return response.data;
};

// Get single clause
const getSingleClause = async (data) => {
  const response = await axiosPrivate.get(`${GET_SINGLE_CLAUSES}/${data.id}/${data.policy_category}`);
  return response.data;
};

// update clause
const updateClause = async (clauseData) => {
  const response = await axiosPrivate.post(
    `${UPDATE_CLAUSE}/${clauseData.id}}`,
    clauseData
  );
  return response.data;
};

const clauseService = {
  createClause,
  getAllClauses,
  getSingleClause,
  updateClause,
};

export default clauseService;
